module.exports = __webpack_public_path__ + "banner.62ce9e54.png";